// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation } from "@altostra/type-validations/lib/primitives";
import { isIpPool } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

export const isPostCompaniesCompanyIdEmailSelfServeIpPoolResult = objectOf({
  ipPool: anyOf(isIpPool, nullValidation),
});
